import * as React from 'react'
import joinClassNames from '../../../helpers/joinClassNames'

type Props = {
    children: React.ReactNode
    isSubmitted?: boolean
    isSmall?: boolean
    className?: string
}

const FormTitle = ({isSubmitted, isSmall, children, className}: Props) => {
    return (
        <h2
            className={joinClassNames(
                'has-text-weight-bold',
                isSubmitted ? 'has-text-success' : null,
                isSmall ? 'is-size-3' : 'is-size-2',
                isSmall ? 'is-size-4-mobile' : 'is-size-3-mobile',
                className
            )}
            style={{lineHeight: 1.25}}
        >
            {children}
        </h2>
    )
}

export default FormTitle
